import React from 'react';
import { SITE } from '@/constants/testIds';
import { scrollToId } from '@/lib/lenis';

const COLS = [
  {
    title: 'Practice',
    links: [
      { l: 'Investment Banking', t: 'what' },
      { l: 'Mergers & Acquisitions', t: 'what' },
      { l: 'Strategic Project Advisory', t: 'what' },
    ],
  },
  {
    title: 'Firm',
    links: [
      { l: 'Approach', t: 'approach' },
      { l: 'Sectors', t: 'sectors' },
      { l: 'Team', t: 'team' },
      { l: 'Selected Work', t: 'work' },
    ],
  },
  {
    title: 'Reach',
    links: [
      { l: 'India', t: 'reach' },
      { l: 'MENA', t: 'reach' },
      { l: 'Hong Kong', t: 'reach' },
    ],
  },
];

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid={SITE.footer}
      className="section-dark px-5 md:px-10 pt-20 pb-10 border-t border-[color:var(--rule-dark)]"
    >
      <div className="container-narrow">
        <div className="grid grid-cols-12 gap-8 md:gap-12">
          {/* Wordmark + tagline */}
          <div className="col-span-12 md:col-span-4">
            <p className="font-serif text-[32px] md:text-[38px] leading-none tracking-[-0.015em] text-[color:var(--stone)]">
              NoBS <span className="text-[color:var(--gold-2)]">Advisors</span>
            </p>
            <p className="mt-6 text-[14.5px] leading-[1.6] text-[color:var(--stone-2)] max-w-[340px]">
              Senior-led investment banking for founders, promoters and
              businesses navigating capital, partnerships and complex
              transactions.
            </p>
            <p className="mt-6 small-caps text-[11px] text-[color:var(--gold-2)]">
              Execution Driven · Investment Banking · Unlike Everyone Else
            </p>
          </div>

          {/* Nav columns */}
          <div className="col-span-12 md:col-span-6 grid grid-cols-2 sm:grid-cols-3 gap-8">
            {COLS.map((col) => (
              <div key={col.title}>
                <p className="small-caps text-[11px] text-[color:var(--stone-3)]">
                  {col.title}
                </p>
                <ul className="mt-4 space-y-2.5">
                  {col.links.map((link) => (
                    <li key={link.l}>
                      <button
                        onClick={() => scrollToId(link.t)}
                        className="text-[14px] text-[color:var(--stone)] hover:text-[color:var(--gold-2)] transition-colors text-left"
                      >
                        {link.l}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Direct */}
          <div className="col-span-12 md:col-span-2">
            <p className="small-caps text-[11px] text-[color:var(--stone-3)]">
              Direct
            </p>
            <a
              href="mailto:mk@no-bs.in"
              className="mt-4 block text-[14px] text-[color:var(--stone)] hover:text-[color:var(--gold-2)] transition-colors"
            >
              mk@no-bs.in
            </a>
            <a
              href="tel:+919324805849"
              className="mt-2 block text-[14px] text-[color:var(--stone)] hover:text-[color:var(--gold-2)] transition-colors"
            >
              +91 93248-05849
            </a>
            <address className="mt-4 not-italic text-[13px] leading-[1.5] text-[color:var(--stone-2)]">
              Powai, Mumbai — 400076
              <br />
              Maharashtra, India
            </address>
          </div>
        </div>

        <div className="mt-16 h-px bg-[color:var(--rule-dark)]" />

        <div className="mt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <p className="small-caps text-[10.5px] text-[color:var(--stone-3)]">
            © {year} NoBS Advisors — All rights reserved.
          </p>
          <p className="small-caps text-[10.5px] text-[color:var(--stone-3)]">
            Boutique IB · M&amp;A · Strategic Advisory · India × MENA × Hong Kong
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
